import React from 'react';
import { ArrowRight, Zap } from 'lucide-react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const CTASection = () => {
  const { t } = useTranslation();
  return (
    <section className="py-24 px-6" data-testid="cta-section">
      <div className="max-w-4xl mx-auto text-center">
        <div className="relative p-12 md:p-16 rounded-3xl bg-gradient-to-b from-[#0055FF]/20 to-transparent border border-[#0055FF]/30 overflow-hidden">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-96 bg-[#0055FF]/30 rounded-full blur-[100px] pointer-events-none"></div>

          <div className="relative z-10">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-[#0055FF] mb-8">
              <Zap className="w-8 h-8 text-white" strokeWidth={1.5} />
            </div>

            <h2 className="font-['Outfit'] text-4xl sm:text-5xl font-medium tracking-tight mb-6">
              {t('cta.title')}
            </h2>

            <p className="text-xl text-[#A1A1AA] mb-8 max-w-2xl mx-auto">{t('cta.subtitle')}</p>

            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/register">
                <Button
                  className="bg-white text-black hover:bg-white/90 rounded-full px-8 py-6 text-lg font-medium group"
                  data-testid="cta-primary-btn"
                >
                  {t('cta.primary')}
                  <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
              <Link to="/contact">
                <Button
                  variant="outline"
                  className="border-white/30 text-white hover:bg-white/5 rounded-full px-8 py-6 text-lg"
                  data-testid="cta-secondary-btn"
                >
                  {t('cta.secondary')}
                </Button>
              </Link>
            </div>

            <p className="mt-8 text-sm text-[#A1A1AA]">{t('cta.note')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
